import { recipients } from './recipients';
import { recipients_range } from './recipients_range';

export const form = {
  namespaced: true,
  modules: {
    recipients,
    recipients_range
  }
};
